import { setHtmlBySelector } from './utils';
const csp = require('country-state-picker');
const us_states = require('./us_states.json');
const ca_states = require('./canadian_states.json');

window.csp = csp;



function setupCountryFields(meta) {
  let zones = [];
  let useAll = false;

  if (meta && meta.shippingZones) {
    zones = meta.shippingZones;
    if (zones.indexOf("DEFAULT") > -1) {
      useAll = true;
    }
  }


  //let innerHtml = '<option value="US">United States</option>';
  let innerHtml = '';
  let countries = csp.getCountries();

  // Inject UK as an option....
  countries.push({
    name: "United Kingdom",
    code: "gb"
  });


  countries.sort((a,b) => {
    return a.name > b.name ? 1 : -1;
  });


  for (const country of countries) {
    const code = country.code.toUpperCase();

    const countryName = country.name === "United States of America" ? "United States" : country.name;

    if (useAll || zones.indexOf(code) > -1) {
      innerHtml += `<option value=${code}>${countryName}</option>`;
    }
  }

  setHtmlBySelector('[name="billing_country"],[name="shipping_country"],[name="paypal_checkout_country"],[name="stripe_checkout_country"]', innerHtml);

}


function setupCcFields() {
  const expMonths = `
    <option value="">- Select Exp Month -</option>
    <option value="1">01 - January</option>
    <option value="2">02 - Febuary</option>
    <option value="3">03 - March</option>
    <option value="4">04 - April</option>
    <option value="5">05 - May</option>
    <option value="6">06 - June</option>
    <option value="7">07 - July</option>
    <option value="8">08 - August</option>
    <option value="9">09 - September</option>
    <option value="10">10 - October</option>
    <option value="11">11 - November</option>
    <option value="12">12 - December</option>
  `;


  setHtmlBySelector('[name="cc_exp_month"]', expMonths);

  let expirations = '<option value="">- Select Exp Year -</option>';
  const curYear = (new Date()).getFullYear();
  for (let year=curYear; year < (curYear+25); year++) {
    expirations += `<option value="${year}">${year}</option>`;
  }

  setHtmlBySelector('[name="cc_exp_year"]', expirations);

}


export default function(meta) {
  setupCcFields();
  setupCountryFields(meta);
}





export function setupStateFields(curCountry = 'us') {

  curCountry = curCountry.toLowerCase();

  let stateOptions = `<option value="">- Select State -</option>`;

  if (curCountry === 'us') {

    for (const [abbr,name] of Object.entries(us_states)) {
      stateOptions += `<option value="${abbr}">${name}</option>`;
    }

  } else if (curCountry === 'ca') {
    for (const [abbr,name] of Object.entries(ca_states)) {
      stateOptions += `<option value="${abbr}">${name}</option>`;
    }
  } else {

    let states = csp.getStates(curCountry);

    // Request to remove prefix on state names that look weird to locals.
    if (curCountry === 'au') {
      states = states.map(x => x.replace(/^State of /, ""));
    }

    if (states && states.length) {
      states.forEach(s => {
        stateOptions += `<option value="${s}">${s}</option>`;
      });
    } else {
      stateOptions += `<option value="N/A">N/A</option>`;

    }
  }


  try {
    setHtmlBySelector('select[name="shipping_state"], select[name="billing_state"], .shipping_state', stateOptions);
  } catch {
    // Ignore
  }

}
